var res = [{"key":"10/11","value":"86.0"},{"key":"11/12","value":"63.2"},{"key":"12/13","value":"56.7"},{"key":"13/14","value":"59.8"},{"key":"14/15","value":"52.8"},{"key":"15/16","value":"45.8"},{"key":"16/17","value":"49.5"}];res.columns = ["key","value"];module.exports = res;


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/interuptions-east.csv
// module id = 617
// module chunks = 0